import { useState } from "react";
import { api } from "../../services/apiService";
import ConfirmModal from "../../components/ConfirmModal/ConfirmModal";

export default function usePerfis() {
  const [perfis, setPerfis] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    type: "confirm",
    message: "",
    onConfirm: null,
  });

  const listarPerfis = async (page = 1, pageSize = 20) => {
    try {
      const response = await api.perfil.getAll(page, pageSize);
      const payload = response?.data || response || {};
      setTotalCount(payload.totalCount ?? 0);
      setPerfis(payload.items || []);
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        "Erro ao carregar perfis.";
      alert(msg);
    }
  };

  const excluirPerfil = async (id, nome, page) => {
    setModalConfig({
      type: "confirm",
      message: `Deseja realmente excluir o perfil "${nome}"?`,
      onConfirm: async () => {
        try {
          await api.perfil.delete(id);

          setModalConfig({
            type: "success",
            message: "Perfil excluído com sucesso!",
            onConfirm: null,
          });

          listarPerfis(page);
          setTimeout(() => setShowModal(false), 2000);
        } catch (error) {
          let message =
            error.response?.data?.message || "Erro ao excluir perfil.";
          if (error.response?.status === 403) {
            message = "Você não tem permissão para essa ação.";
          }
          setModalConfig({
            type: "error",
            message,
            onConfirm: null,
          });
        }
      },
    });
    setShowModal(true);
  };

  return {
    perfis,
    totalCount,
    listarPerfis,
    excluirPerfil,
    ModalComponent: (
      <ConfirmModal
        show={showModal}
        type={modalConfig.type}
        message={modalConfig.message}
        onConfirm={modalConfig.onConfirm}
        onClose={() => setShowModal(false)}
      />
    ),
  };
}
